import { SurfaceActionItem } from 'owa-surface-actions';
import CLPLabel from 'owa-mail-protection-types/lib/schema/CLPLabel';
import CLPViewState from 'owa-mail-protection-types/lib/schema/clp/CLPViewState';
import setTempCLPLabel from '../../actions/clp/setTempCLPLabel';

export default function getLabelDropdown(
    labels: CLPLabel[],
    setSelectedLabel,
    viewState: CLPViewState
) {
    if (!labels || labels.length <= 0) {
        return [];
    }
    let subMenuProps: SurfaceActionItem[] = [];
    labels
        .filter(label => label.isLabelEnabled)
        .forEach(label => {
            subMenuProps.push({
                name: label.displayName,
                title: label.tooltip,
                onClick: () => {
                    setSelectedLabel(label);
                    setTempCLPLabel(viewState, label);
                },
                key: label.id,
                subMenuProps:
                    label.children &&
                    label.children.filter(childLabel => childLabel.isLabelEnabled).length > 0
                        ? {
                              items: getLabelDropdown(label.children, setSelectedLabel, viewState),
                          }
                        : null,
            });
        });
    return subMenuProps;
}
